import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tab-content',
  templateUrl: './tab-content.component.html',
  styleUrls: ['./tab-content.component.scss'],
})
export class TabContentComponent {

  public title: string = 'Corporate safety - Crew Self Service';
  @Input() isDesktop:boolean =false;
  @Input() selectedTab:string = '';
  isFrontImageLoaded:boolean = false;
  isBackImageLoaded:boolean = false;

  onImageLoad(side:string){
    if(side === 'front')
      this.isFrontImageLoaded = true;
    if(side === 'back')
      this.isBackImageLoaded = true;
  }
}
